import { minutesTime } from "../lib/calendar";

const HOURS = Array.from({ length: 11 }, (_, index) => 9 + index);
const topFor = (minutes) => `${(minutes - 540) * 1.02}px`;
const heightFor = (start, end) => `${Math.max(28, (end - start) * 1.02)}px`;

export const DayTimeline = ({ day, presenter, onBook, onOutcome }) => {
  const row = day?.rows.find((item) => item.presenter_id === presenter?.id);
  if (!row) return <p className="agenda-no-presenters" data-testid="day-no-presenter">Nessuna disponibilità.</p>;
  return (
    <div className="agenda-timeline" data-testid="agenda-day-timeline">
      {HOURS.map((hour) => <div className="agenda-hour" key={hour} style={{ top: topFor(hour * 60) }} data-testid={`agenda-hour-${hour}`}><span>{hour}:00</span></div>)}
      <div className="agenda-time-grid" aria-hidden="true" />
      {row.free.map((free, index) => <button type="button" key={`free-${index}`} className="agenda-free-block"
        style={{ top: topFor(free.start_min), height: heightFor(free.start_min, free.end_min) }}
        data-testid={`agenda-free-${index}`} aria-label={`Libero dalle ${minutesTime(free.start_min)} alle ${minutesTime(free.end_min)}. Fissa`}
        onClick={(event) => {
          if (day.past) return;
          const rect = event.currentTarget.getBoundingClientRect();
          const fraction = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
          const minute = Math.min(free.end_min - 15, free.start_min + Math.floor((fraction * (free.end_min - free.start_min)) / 15) * 15);
          onBook({ presenterId: presenter.id, presenterName: presenter.name, date: day.date, time: minutesTime(minute) });
        }}><span>LIBERO {minutesTime(free.start_min)} + FISSA</span></button>)}
      {row.appointments.map((meeting, index) => meeting.mine ? <button type="button" key={`meeting-${index}`} className="agenda-meeting-block mine"
        style={{ top: topFor(meeting.start_min), height: heightFor(meeting.start_min, meeting.end_min) }}
        onClick={() => onOutcome(meeting.id)} data-testid={`agenda-meeting-${meeting.id}`}>
        <strong>{minutesTime(meeting.start_min)} {meeting.label}</strong><span>{meeting.meeting_number}° incontro{meeting.outcome ? ` · ${meeting.outcome}` : ""}</span>
      </button> : <div key={`meeting-${index}`} className="agenda-meeting-block busy"
        style={{ top: topFor(meeting.start_min), height: heightFor(meeting.start_min, meeting.end_min) }}
        data-testid={`agenda-busy-${index}`}><strong>OCCUPATO</strong></div>)}
    </div>
  );
};